/**
 * Returns static lists of shape and color values for Avatars
 * Returns function to get a random Avatar id, optionally excluding keys already assigned to other profiles
 *
 * @returns {object}
 */
const useAvatars = () => {
  const shapes = [
    {
      key: 'shape1',
      path: 'M16.257.138a.32.32 0 0 0-.55 0L12.69 5.169a.32.32 0 0 1-.4.13L6.891 3.002a.32.32 0 0 0-.444.323l.516 5.845a.32.32 0 0 1-.247.34L.998 10.825a.32.32 0 0 0-.17.522l3.853 4.425a.32.32 0 0 1 0 .42L.828 20.617a.32.32 0 0 0 .17.522l5.718 1.316a.32.32 0 0 1 .247.34l-.516 5.844a.32.32 0 0 0 .444.323l5.4-2.297a.32.32 0 0 1 .399.13l3.018 5.032a.32.32 0 0 0 .549 0l3.018-5.032a.32.32 0 0 1 .4-.13l5.398 2.297a.32.32 0 0 0 .444-.323l-.516-5.844a.32.32 0 0 1 .247-.34l5.719-1.316a.32.32 0 0 0 .17-.522l-3.854-4.425a.32.32 0 0 1 0-.42l3.853-4.425a.32.32 0 0 0-.17-.522L25.249 9.51a.32.32 0 0 1-.247-.34l.516-5.845a.32.32 0 0 0-.444-.323L19.674 5.3a.32.32 0 0 1-.4-.13zM16 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16'
    },
    {
      key: 'shape2',
      path: 'M16.04 32c-.504 0-.93-.365-1.053-.855q-.585-2.34-2.237-4.978-1.959-3.168-5.583-5.875-3.153-2.383-6.306-3.25C.363 16.905 0 16.463 0 15.947c0-.506.35-.942.836-1.081q3.09-.883 5.956-2.866 3.29-2.292 5.5-5.5 1.953-2.858 2.682-5.653C15.1.359 15.53 0 16.035 0c.51 0 .943.366 1.067.861q.42 1.675 1.315 3.43 1.125 2.168 2.875 4.167a25.7 25.7 0 0 0 4 3.542q2.886 2.046 5.867 2.874c.488.136.841.57.841 1.076 0 .514-.364.951-.86 1.087q-1.89.519-3.89 1.671a25 25 0 0 0-4.5 3.375Q20.667 24 19.333 26.125q-1.655 2.643-2.24 5.017c-.12.491-.547.858-1.052.858'
    },
    {
      key: 'shape3',
      path: 'M16.062 14.697C15.399 6.47 8.512 0 .114 0c0 8.359 6.41 15.22 14.583 15.938C6.47 16.601 0 23.488 0 31.886c8.359 0 15.22-6.41 15.938-14.582C16.601 25.53 23.488 32 31.886 32c0-8.359-6.41-15.22-14.582-15.938C25.53 15.399 32 8.512 32 .114c-8.359 0-15.22 6.41-15.938 14.583M16 16'
    },
    {
      key: 'shape4',
      path: 'm16 0 4.526 11.475L32 16l-11.474 4.526L16 32l-4.525-11.474L0 16l11.475-4.525z'
    },
    {
      key: 'shape5',
      path: 'M8.114 0h-8v8a8 8 0 0 0 6.984 7.936A8 8 0 0 0 0 23.886v8h8a8 8 0 0 0 7.936-6.984A8 8 0 0 0 23.886 32h8v-8a8 8 0 0 0-6.984-7.936A8 8 0 0 0 32 8.114v-8h-8a8 8 0 0 0-7.936 6.984A8 8 0 0 0 8.114 0'
    },
    {
      key: 'shape6',
      path: 'M20.357 17.65c2.98 1.127 6.99.922 9.544-.49L32 16l-2.099-1.16c-2.553-1.412-6.564-1.617-9.544-.49l-2.234.847q-.022-.067-.047-.133l2.171-.979c2.905-1.31 5.595-4.29 6.403-7.094l.664-2.305-2.305.664c-2.803.807-5.785 3.498-7.094 6.403l-.946 2.097a2 2 0 0 0-.132-.06l.812-2.147c1.128-2.98.922-6.99-.489-9.544L16 0l-1.16 2.099c-1.412 2.553-1.617 6.564-.49 9.544l.813 2.147q-.067.029-.132.06l-.946-2.097c-1.31-2.905-4.29-5.595-7.094-6.403l-2.305-.664.664 2.305c.807 2.803 3.498 5.785 6.403 7.094l2.171.98q-.025.064-.047.132l-2.234-.846c-2.98-1.128-6.99-.923-9.544.489L0 16l2.099 1.16c2.553 1.412 6.564 1.617 9.544.49l2.339-.886q.027.06.058.12l-2.287 1.03c-2.905 1.31-5.595 4.292-6.403 7.095l-.664 2.305 2.305-.664c2.803-.807 5.785-3.498 7.094-6.402l1.061-2.355q.06.024.12.044l-.915 2.42c-1.128 2.98-.923 6.99.489 9.544l1.16 2.1 1.16-2.1c1.412-2.553 1.617-6.564.49-9.544l-.917-2.42q.06-.02.12-.044l1.062 2.354c1.31 2.905 4.29 5.595 7.094 6.403l2.305.664-.664-2.305c-.807-2.803-3.498-5.785-6.402-7.094l-2.288-1.031q.031-.06.058-.12z'
    },
    {
      key: 'shape7',
      path: 'M16 0c.543 8.602 7.398 15.457 16 16-8.602.543-15.457 7.398-16 16-.543-8.602-7.398-15.457-16-16 8.602-.543 15.457-7.398 16-16'
    },
    {
      key: 'shape8',
      path: 'M16 27.798C3.898 37.911-5.911 28.102 4.202 16-5.911 3.898 3.898-5.911 16 4.202 28.1-5.911 37.911 3.898 27.798 16 37.911 28.093 28.1 37.911 16 27.798'
    },
    {
      key: 'shape9',
      path: 'M2.949 10.594a6.42 6.42 0 0 1 1.737-5.908 6.42 6.42 0 0 1 5.908-1.737A6.42 6.42 0 0 1 16 0a6.42 6.42 0 0 1 5.406 2.949 6.42 6.42 0 0 1 5.908 1.737 6.42 6.42 0 0 1 1.737 5.908A6.42 6.42 0 0 1 32 16a6.42 6.42 0 0 1-2.949 5.406 6.42 6.42 0 0 1-1.737 5.908 6.42 6.42 0 0 1-5.908 1.737A6.42 6.42 0 0 1 16 32a6.42 6.42 0 0 1-5.406-2.949 6.42 6.42 0 0 1-5.908-1.737 6.42 6.42 0 0 1-1.737-5.908A6.42 6.42 0 0 1 0 16a6.42 6.42 0 0 1 2.949-5.406m8.484 9.965a6.429 6.429 0 1 0 9.09-9.092 6.429 6.429 0 0 0-9.09 9.092'
    },
    {
      key: 'shape10',
      path: 'M15.996 16C7.161 15.998 0 8.835 0 0h32c0 8.835-7.161 15.998-15.996 16C24.839 16.002 32 23.165 32 32H0c0-8.835 7.161-15.998 15.996-16'
    },
    {
      key: 'shape11',
      path: 'M32 16.107 16 0 0 16.107h15.787L0 32h32L16.213 16.107z'
    },
    {
      key: 'shape12',
      path: 'M24.97 23.03 17.94 16l7.03-7.03L32 16zm-17.94 0L0 16l7.03-7.03L14.06 16zM16 32l-7.03-7.03L16 17.94l7.03 7.03zm0-17.94L8.97 7.03 16 0l7.03 7.03z'
    }
  ];
  const colors = [
    {
      key: 'purple',
      background: '#EEEDFD',
      icon: '#4B00E0'
    },
    {
      key: 'red',
      background: '#FFEBEE',
      icon: '#EE2C4C'
    },
    {
      key: 'orange',
      background: '#FDEFE2',
      icon: '#F27910'
    },
    {
      key: 'green',
      background: '#E7F9F3',
      icon: '#23936F'
    },
    {
      key: 'blue',
      background: '#EDEEFD',
      icon: '#1629DA'
    },
    {
      key: 'cyan',
      background: '#ECFAFE',
      icon: '#1FA0C7'
    },
    {
      key: 'lime',
      background: '#F2FFD1',
      icon: '#6E9609'
    },
    {
      key: 'apricot',
      background: '#FFF7E0',
      icon: '#D99B00'
    }
  ];
  /**
   * Returns a random Avatar id, optionally excluding keys passed in param
   *
   * @param {array} usedAvatars - Optional - array of avatar keys (strings)
   * @returns {string} - formatted avatar key - shapeKey:colorKey - ex: shape1:cyan
   */
  const getRandomKey = (usedAvatars) => {
    let availableShapes = shapes;
    let availableColors = colors;
    if (usedAvatars) {
      // exclude colors/shapes already used by other profiles
      const usedColors = [];
      const usedShapes = [];
      usedAvatars.forEach((key) => {
        // split out avatar key and save values to exclude when randomizing new avatar
        if (key && key.includes(':')) {
          const splitKeys = key.split(':');
          usedShapes.push(splitKeys[0]);
          usedColors.push(splitKeys[1]);
        }
      });
      // filter shapes and colors list to remove any values from existingColors/Shapes
      availableShapes = shapes.filter(
        (shape) => !usedShapes.includes(shape.key)
      );
      availableColors = colors.filter(
        (color) => !usedColors.includes(color.key)
      );
    }

    const getRandom = (array) => {
      return array[Math.floor(Math.random() * array.length)];
    };
    // assign a key with a random shape and color that hasn't already been assigned to another profile on the account
    const randomShape = getRandom(availableShapes);
    const randomColor = getRandom(availableColors);
    const avatarKey = `${randomShape.key}:${randomColor.key}`;
    return avatarKey;
  };
  return { shapes, colors, getRandomKey };
};

export default useAvatars;
